import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppState } from '../storage/app-state';
import { UserRole } from '../models/database.types';

export const adminRoleGuard: CanActivateFn = async () => {
  const appState = inject(AppState);
  const router = inject(Router);

  // 1. Check: User aus AppState abrufen
  const user = appState.user();
  
  if (!user) {
    router.navigate(['/dashboard']);
    return false;
  }

  // 2. Check: Ist der User Admin oder Super-Admin?
  const hasAdminAccess = user.role === UserRole.ADMIN || user.role === UserRole.SUPERADMIN;
  
  if (!hasAdminAccess) {
    router.navigate(['/dashboard']);
    return false;
  }

  return true;
};
